import { MutationTree } from "vuex"
import {
    Contact,
    Institution,
    Insurance,
    Period,
    WidgetState
} from "@/apps/StudentExchangeNonPartnerWidget/models/store-viewmodel"
import { ILabels, ILanguage } from "@/apps/StudentExchangeNonPartnerWidget/models/config-viewmodel";

export default <MutationTree<WidgetState>>{
    loading(state, loading: boolean) {
        state.loading = loading
    },
    canContinue(state, canContinue: boolean) {
        state.canContinue = canContinue
    },
    labels(state, labels: ILabels) {
        state.labels = labels
    },
    period(state, period: Period) {
        state.period = period
    },
    contact(state, contact: Contact) {
        state.contact = contact
    },
    institution(state, institution: Institution) {
        state.institution = institution
    },
    insurance(state, insurance: Insurance) {
        state.insurance = insurance
    },
    editable(state, editable: boolean) {
        state.editable = editable
    },
    cancelable(state, cancelable: boolean) {
        state.cancelable = cancelable
    },
    programId(state, programId: number) {
        state.programId = programId
    },
    exchangeId(state, exchangeId: string) {
        state.exchangeId = exchangeId
    },
    academicYearId(state, academicYearId: number) {
        state.academicYearId = academicYearId
    },
    language(state, language: ILanguage) {
        state.language = language
    },
    errorMessage(state, errorMessage: string) {
        state.errorMessage = errorMessage
    },
    studyName(state, studyName: string) {
        state.studyName = studyName
    },
    isSubmitted(state, isSubmitted: boolean) {
        state.isSubmitted = isSubmitted
    },
    periodIsInvalid(state, periodIsInvalid: boolean) {
        state.periodIsInvalid = periodIsInvalid
    },
    contactIsInvalid(state, contactIsInvalid: boolean) {
        state.contactIsInvalid = contactIsInvalid
    }
}
